import { palette } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

interface Props {
  style?: any;

  left?: JSX.Element | null;
  center?: JSX.Element | null;
  right?: JSX.Element | null;
}

const HeaderBar: FC<Props> = (props) => (
  <Bar style={props.style}>
    <LeftSide>{props.left}</LeftSide>
    <View>{props.center}</View>
    <RightSide>{props.right}</RightSide>
  </Bar>
);

const Bar = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${palette.white};
  padding: 16px;
`;

const LeftSide = styled.View`
  flex: 1;
`;

const RightSide = styled.View`
  flex: 1;
  flex-direction: row;
  justify-content: flex-end;
`;

export default HeaderBar;
